import React from 'react';
import './SelectionBox.css';

const SelectionBox = ({ startPoint, endPoint, isSelecting }) => {
  if (!isSelecting || !startPoint || !endPoint) {
    return null;
  }

  const left = Math.min(startPoint.x, endPoint.x);
  const top = Math.min(startPoint.y, endPoint.y);
  const width = Math.max(1, Math.abs(endPoint.x - startPoint.x)); // Minimum 1px width
  const height = Math.max(1, Math.abs(endPoint.y - startPoint.y)); // Minimum 1px height

  return (
    <div
      className="selection-box"
      style={{
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        height: `${height}px`,
      }}
    />
  );
};

export default SelectionBox;